import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
/** @jsx jsx */

import { forwardRef } from 'react';
import { jsx } from '@emotion/core';
import Button from '@atlaskit/button/custom-theme-button';
import Tooltip from '@atlaskit/tooltip';
import { useTheme } from '../../theme';
import { getPrimaryButtonTheme, isHighlightedCSS } from './styles';
export var PrimaryButton =
/*#__PURE__*/
forwardRef(function (props, ref) {
  var children = props.children,
      testId = props.testId,
      tooltip = props.tooltip,
      isSelected = props.isSelected,
      isHighlighted = props.isHighlighted,
      buttonProps = _objectWithoutProperties(props, ["children", "testId", "tooltip", "isSelected", "isHighlighted"]);

  var theme = useTheme();
  var button = jsx("div", {
    css: isHighlightedCSS(theme, isHighlighted)
  }, jsx(Button, _extends({
    appearance: "primary",
    testId: testId,
    ref: ref,
    isSelected: isSelected,
    theme: getPrimaryButtonTheme(theme)
  }, buttonProps), children));

  if (tooltip) {
    return jsx(Tooltip, {
      content: tooltip,
      hideTooltipOnClick: true
    }, button);
  }

  return button;
});
export default PrimaryButton;